// eslint-disable-next-line @nx/enforce-module-boundaries
import { OfferProgressFormatVariant } from '@ocx-app/components/OfferCard/offer-card.types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { intl } from '@ocx-app/lib/translation/TranslationProvider';

type FormatOfferProgressValueParams = {
  value: number;
  variant?: OfferProgressFormatVariant;
  currency?: string;
};

const DEFAULT_CURRENCY = 'USD';

export const formatOfferProgressValue = ({
  value,
  variant = 'quantity',
  currency,
}: FormatOfferProgressValueParams): string | number => {
  if (variant === 'money-amount') {
    return intl.formatNumber(value, {
      style: 'currency',
      currency: currency || DEFAULT_CURRENCY,
      maximumFractionDigits: 2,
      minimumFractionDigits: 0,
    });
  }

  return value;
};
